import $ from 'jquery';
import AirDatepicker from 'air-datepicker';
import localeEn from 'air-datepicker/locale/en';
import localeDe from 'air-datepicker/locale/de';

let locale;
if ($('html').attr('lang') === 'de') {
    locale = localeDe;
} else {
    locale = localeEn;
}

let defaultConfig = {
    locale: locale,
    autoClose: true,
    onSelect: ({datepicker}) => $(datepicker.$el).trigger('input').trigger('change'),
};

function getMinDate($element, config) {
    let minDate = $element.attr('data-min-date');
    if (minDate === 'now') {
        return {...config, minDate: new Date()}
    } else if (minDate) {
        return {...config, minDate: new Date(minDate)}
    }
    return config;
}

let $elements = $('.datepicker-input');
$elements.each((i, element) => {
    let config = getMinDate($(element), defaultConfig);
    element._airDatepickerInstance = new AirDatepicker(element, config);
});

$('.datepicker-pair').each((i, elem) => {
    let $elem = $(elem);
    let $startField = $elem.find('.datepicker-input-start');
    let $endField = $elem.find('.datepicker-input-end');

    let endConfig = getMinDate($endField, defaultConfig);
    let endDatePicker = new AirDatepicker($endField[0], endConfig);
    $endField[0]._airDatepickerInstance = endDatePicker;

    let startConfig = {
        ...defaultConfig,
        onSelect: function ({date, datepicker}) {
            date.setDate(date.getDate() + 1);
            endDatePicker.update({
                minDate: date
            });
            // check if date is below minDate
            if (
                endDatePicker.selectedDates.length > 0
                && endDatePicker.selectedDates.some(d => d < date)
            ) {
                endDatePicker.selectDate(date);
                window.setTimeout(() => $(datepicker.$el).trigger('input').trigger('change'));
            } else {
                $(datepicker.$el).trigger('input').trigger('change');
            }
        }
    };
    startConfig = getMinDate($startField, startConfig);
    $startField[0]._airDatepickerInstance = new AirDatepicker($startField[0], startConfig);
});
